import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaUsers, FaUserCheck, FaCogs, FaIndustry, FaFileContract, FaComments } from "react-icons/fa";


export default function WhyChooseUs() {
  const [activeCardIndex, setActiveCardIndex] = useState(null);

/*   const icons = [
    // Users icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2A5 5 0 0 0 7 7a5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5zm-7 13.5A7.5 7.5 0 0 0 12 22a7.5 7.5 0 0 0 7-6.5c-.83-3.05-3.35-5.57-6.4-6.4a5.5 5.5 0 0 0-1.2-.1c-3.1.8-5.63 3.33-6.43 6.4m11.53.5l1.65 1.65c.6.6 1.4.95 2.22.95s1.62-.35 2.22-.95c.6-.6.95-1.4.95-2.22s-.35-1.62-.95-2.22l-1.65-1.65c-.7-.7-1.7-.7-2.4 0-.7.7-.7 1.7 0 2.4l1.65 1.65z" /></svg>,
    // User check icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2A5 5 0 0 0 7 7a5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5zm-7 13.5A7.5 7.5 0 0 0 12 22a7.5 7.5 0 0 0 7-6.5c-.83-3.05-3.35-5.57-6.4-6.4a5.5 5.5 0 0 0-1.2-.1c-3.1.8-5.63 3.33-6.43 6.4m11.53.5l1.65 1.65c.6.6 1.4.95 2.22.95s1.62-.35 2.22-.95c.6-.6.95-1.4.95-2.22s-.35-1.62-.95-2.22l-1.65-1.65c-.7-.7-1.7-.7-2.4 0-.7.7-.7 1.7 0 2.4l1.65 1.65z" /></svg>,
    // Cogs icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-9.9 10.1 10 10 0 0 0 10.1 9.9 10 10 0 0 0 9.9-10.1A10 10 0 0 0 12 2zm0 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-2-4a2 2 0 1 0 4 0 2 2 0 0 0-4 0z" /></svg>,
    // Industry icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22v-2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6 0-.2 0-.4 0-.6v-2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6v-2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6v-2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6v-2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6v-2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6zm-1-19.5c.3.2.5.4.7.6.2.2.4.4.6.6.2.2.3.4.4.6.1.2.2.4.3.6.1.2.2.4.2.6.1.2.1.4.1.6v2c-.3-.2-.5-.4-.7-.6-.2-.2-.4-.4-.6-.6-.2-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.6-.1-.2-.2-.4-.2-.6-.1-.2-.1-.4-.1-.6z" /></svg>,
    // File contract icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v4h5v12zM8 9h8v2H8V9zm0 4h8v2H8v-2zm0 4h5v2H8v-2z" /></svg>,
    // Comments icon
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2h12v2H6zm8-3H6V9h8v2zm4-4H6V5h12v2z" /></svg>,
  ]; */

    const icons = [
    <FaUsers />,
    <FaUserCheck />,
    <FaCogs />,
    <FaIndustry />,
    <FaFileContract />,
    <FaComments />,
  ];

  const features = [
    "DEDICATED TEAM",
    "FIRST PRIORITY – CUSTOMERS",
    "WELL TRAINED EXPERTS",
    "INDUSTRY EXPERIENCE",
    "CUSTOMIZABLE CONTRACTS",
    "COMMUNICATION",
  ];

  const descriptions = [
    "We provide a dedicated team of professionals who are focused on your business goals and success, ensuring a high level of personalized service.",
    "Our clients are our top priority. We are committed to building long-term relationships and delivering solutions that exceed your expectations.",
    "Our experts undergo continuous training to stay ahead of the curve in digital marketing, bringing you the latest strategies and technologies.",
    "With extensive experience across various industries, we understand the unique challenges and opportunities of your market.",
    "Our contracts are flexible and can be customized to fit your specific needs, budgets, and business objectives.",
    "We believe in transparent and open communication. You'll be kept in the loop every step of the way with regular updates and clear reports.",
  ];

  return (
    <div className="py-16 bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-extrabold mb-4">
        Why Choose <span className="text-blue-500">SRK Software</span> as Digital Marketing Partner?
      </h2>
      <p className="max-w-3xl mx-auto text-gray-600 mb-12">
        We deliver straightforward and successful IT solutions, making your brand shine in today&apos;s competitive landscape.
        Start your online presence effortlessly with the support of a leading digital marketing company in India.
      </p>

      {/* Top Icons */}
      <div className="flex justify-center gap-10 mb-10 flex-wrap">
        {icons.map((icon, index) => (
          <motion.div
            key={index}
            className="text-6xl text-orange-500"
            whileHover={{ scale: 1.2, rotate: 10 }}
            whileTap={{ scale: 0.9 }}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
          >
            {icon}
          </motion.div>
        ))}
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-2 md:grid-cols-6 gap-6 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className={`p-3 bg-blue-50 rounded-xl shadow-sm hover:shadow-md transition border-solid border-2 cursor-pointer ${activeCardIndex === index ? 'border-blue-500' : 'border-orange-500'}`}
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
            onClick={() => setActiveCardIndex(index)}
          >
            <p className="font-bold text-gray-800">{feature}</p>
          </motion.div>
        ))}
      </div>

      {/* Description below cards */}
      {activeCardIndex !== null && (
        <motion.div
          key={activeCardIndex}
          className="mt-8 p-6 mx-auto max-w-3xl text-gray-700 bg-gray-100 rounded-xl shadow-inner transition-all duration-300 ease-in-out"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <p className="font-semibold text-blue-600 mb-2">{features[activeCardIndex]}</p>
          <p>{descriptions[activeCardIndex]}</p>
        </motion.div>
      )}
    </div>
  );
}
